<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/basic/process/route/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('gongyiluxianbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyiluxianmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_craft_create')" size="mini" @click="
          yt.showEditDialog('xinzeng', null, 'w1');
        setDefaultValue();
        " type="primary">
          {{ $t("xinzeng") }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #leibie="scope">
        <template v-if="scope.row.type == 1">
          {{ $t("tongyong") }}
        </template>
        <template v-if="scope.row.type == 2">
          {{ $t("teding") }}
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_craft_procedure')" type="text" @click="yt.showEditDialog('gongxu', scope.row, 'w2')">{{ $t("gongxu") }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.type == 2">
            <el-button v-if="utils.checkPower('web_base_craft_productCategory')" type="text" @click="yt.showEditDialog('chanpinfenlei', scope.row, 'w2')"> {{ $t("chanpinfenlei") }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_craft_update')" type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t("bianji") }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.type == 2">
            <el-button v-if="utils.checkPower('web_basic_craft_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/craft/basic/process/route/delete')">{{ $t("shanchu") }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyiluxianbianma')" required>
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyiluxianmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('leibie')" class="noborder" required>
            <el-select disabled v-model="yt.editObj.type">
              <el-option :label="$t('teding')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select :type="'sub_organization'" :ids.sync="yt.editObj.orgId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/process/route/create', null, fetchData)" type="primary">{{ $t("baocun") }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('gongyiluxianbianma')" required>
            <el-input disabled v-model.trim="yt.editObj.code" :disabled="yt.editObj.type == 1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyiluxianmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('leibie')" class="noborder" required>
            <el-select disabled v-model="yt.editObj.type" :disabled="yt.editObj.type == 1">
              <el-option :label="$t('teding')" :value="'2'"></el-option>
              <el-option :label="$t('tongyong')" :value="'1'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select :type="'sub_organization'" :ids.sync="yt.editObj.orgId" :disabled="yt.editObj.type == 1"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/process/route/update', null, fetchData)" type="primary">{{ $t("baocun") }} </el-button>
        </span>
      </template>
      <!-- 工序 -->
      <template v-if="yt.editObj.action == 'gongxu'">
        <div class="dialog-scroller">
          <architecture :craftProcess="yt.editObj"></architecture>
        </div>
      </template>
      <!-- 产品分类 -->
      <template v-if="yt.editObj.action == 'chanpinfenlei'">
        <div class="dialog-scroller">
          <product_category :craft="yt.editObj"></product_category>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// import { Graph } from '@antv/x6';
import architecture from "@@/pages/web/base/craft/architecture";
import product_category from "@@/pages/web/base/craft/product_category";
export default {
  name: "web_base_craft_list",
  components: {
    architecture,
    product_category,
  },
  data() {
    return {
      columns: [
        {
          label: "gongyiluxianbianma",
          prop: "code",
          width: 130,
        },
        {
          label: "gongyiluxianmingcheng",
          prop: "name",
          width: 130,
        },
        {
          label: "leibie",
          prop: "type",
          type: "slot",
        },
        {
          label: "guishuchejian",
          prop: "org.name",
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
        },
        {
          label: "chuangjianshijian",
          prop: "createTime",
          type: "time",
          // format: "YYYY-MM-DD"
        },
        {
          label: "caozuo",
          type: "slot",
          width: 260,
          fixed: "right",
        },
      ],
    };
  },

  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    setDefaultValue() {
      this.yt.editObj.type = 2;
    },
  },
};
</script>
